import { Sparkle } from "lucide-react";

const ITEMS = ["Jodhpur", "Jaipur", "Udaipur", "Jaisalmer", "Mount Abu", "Pushkar", "Ajmer", "Bikaner", "Ranthambore", "Kumbhalgarh", "Ranakpur", "Nathdwara", "Chittorgarh", "Osian"];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-navy py-4 overflow-hidden border-y border-gold/20" aria-hidden="true">
      <div className="marquee-track flex w-max items-center gap-8 whitespace-nowrap">
        {row.map((c, i) => (
          <span key={i} className="flex items-center gap-8 text-sm font-heading font-bold uppercase tracking-[0.25em] text-white/50">
            {c} <Sparkle size={11} className="text-gold" />
          </span>
        ))}
      </div>
    </div>
  );
}
